



























































import ResultadoPorStatus from "./components/ResultadoPorStatus.vue";
import GraficoResultadoPorMotivo from "./components/GraficoResultadoPorMotivo.vue"
import GraficoResultadoPorCanal from "./components/GraficoResultadoPorCanal.vue"
import SelectYearMounth from "@/shared/components/select-year-mounth.vue";
import dayjs from "dayjs";
import Vue from "vue";
import Component from "vue-class-component";
import Tooltip from "@/shared/components/tooltip.vue";

import GraficoResultadoPorEtapa from "./components/GraficoResultadoPorEtapa.vue";
import GraficoRankingTipoLead from "./components/GraficoRankingTipoLead.vue";

@Component({
  components: { 
    SelectYearMounth, 
    ResultadoPorStatus, 
    GraficoResultadoPorMotivo, 
    GraficoResultadoPorEtapa, 
    GraficoResultadoPorCanal, 
    Tooltip,
    GraficoRankingTipoLead,
    },
})
export default class Estatistica extends Vue {
  data: string | null = dayjs().format("YYYY-MM");

  voltar() {
    this.$router.back();
  }

  dashboardMarketing() {
    this.$router.push({
      name: "tv",
      query: {stance: "marketing"},
    });
  }
}
